import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectContent } from "redux/features/dialog/dialogSlice"

export function withModalPaymentAmount<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithModalPaymentAmount = (props: GenericType) => {
    const content = useAppSelector((state) => selectContent(state))

    const { amount } = content
    return <WrappedComponent {...props} amount={amount} />
  }

  return WithModalPaymentAmount
}
